import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { backend_url } from "../App";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Components/Spinner/Spinner";
import TermsAndConditions from "../Components/Info/TermsAndConditions";

const indianStates = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
  "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
  "Uttar Pradesh", "Uttarakhand", "West Bengal",
];

const LoginSignup = () => {
  const [state, setState] = useState("Login");
  const [showTerms, setShowTerms] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
  });
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(300);
  const [canResend, setCanResend] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  // code from the reset email — sent again with the new password (the server checks it)
  const [resetOtp, setResetOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    phoneNumber: "",
    address: "",
    city: "",
    pincode: "",
    country: "",
    state: "",
    whatsappNumber: "",
    dob: "",
    anniversary: "",
  });
  const [profileErrors, setProfileErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  // Page that sent the user here (e.g. a product or the cart) — return them to it after auth.
  const redirectTo = location.state?.from || null;

  // Full reload (not navigate) so ShopContext refetches the cart with the new token
  // and the header/bottom nav pick up the logged-in state.
  const finishAuth = (fallback) => window.location.replace(redirectTo || fallback);

  // Already logged in — no reason to show the form.
  useEffect(() => {
    if (localStorage.getItem("auth-token")) {
      navigate(redirectTo || "/user-profile", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let interval;
    if (step === 2 && timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [step, timer]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min}:${sec < 10 ? "0" + sec : sec}`;
  };

  const handleAuth = async () => {
    // Basic validation for Sign Up
    if (state === "Sign Up") {
      if (!formData.username || !formData.email || !formData.password) {
        toast.error("Please fill in all fields.");
        return;
      }

      // Optional: simple email regex validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        toast.error("Please enter a valid email address.");
        return;
      }

      // Optional: password length check
      if (formData.password.length < 6) {
        toast.error("Password must be at least 6 characters long.");
        return;
      }

      if (!termsAccepted) {
        toast.error("You must accept the terms to continue!");
        return;
      }
    }

    // Basic validation for Login
    if (state === "Login") {
      if (!formData.email || !formData.password) {
        toast.error("Please enter email and password.");
        return;
      }
    }

    setLoading(true);
    try {
      const endpoint = state === "Login" ? "login" : "signup";
      const payload =
        state === "Login"
          ? { email: formData.email, password: formData.password }
          : formData;

      const res = await fetch(`${backend_url}/api/auth/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data && data.success) {
        toast.success("OTP sent to your email.");
        setStep(2);
        setTimer(300);
        setCanResend(false);
      } else {
        toast.error(data?.errors || data?.message);
      }
    } catch (error) {
      toast.error(
        "Something went wrong. Please check your internet or server."
      );
      console.error("handleAuth error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!formData.email || !formData.password) {
      toast.error("Enter email & password");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      console.log(res, "ajshasjskdbas")
      const data = await res.json();
      console.log("Backend response:", data);

      if (data.success) {
        localStorage.setItem("auth-token", data.token);
        toast.success("Login successful");
        finishAuth("/");
      } else {
        toast.error(data.errors || "Invalid credentials");
      }
    } catch (err) {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    setLoading(true);
    try {
      // password reset: check the code without using it up; sign up: verify + log in
      const res = await fetch(`${backend_url}/api/auth/${forgotMode ? "verify-otp-for-reset" : "verify-otp"}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, otp }),
      });

      const data = await res.json();

      if (data && data.success) {
        if (forgotMode) setResetOtp(otp);
        setOtp("");
        if (forgotMode) {
          setStep(3);
        } else {
          localStorage.setItem("auth-token", data.token);
          setStep(4); // Sign Up verified — collect the rest of the profile
        }
      } else {
        toast.error(data?.message || "Invalid OTP. Try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const validateProfilePhone = (v) => {
    if (!v) return "Phone number is required.";
    if (!/^\d{10}$/.test(v)) return "Enter a valid 10-digit number.";
    return "";
  };

  const handleCompleteProfile = async () => {
    const phoneErr = validateProfilePhone(profileDetails.phoneNumber);
    if (phoneErr) {
      setProfileErrors({ phoneNumber: phoneErr });
      return;
    }
    if (
      !profileDetails.address ||
      !profileDetails.city ||
      !profileDetails.pincode ||
      !profileDetails.country
    ) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("auth-token");
      const res = await fetch(`${backend_url}/saveuserdetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "auth-token": token },
        body: JSON.stringify(profileDetails),
      });
      const data = await res.json();
      if (data.success) {
        toast.success("Profile completed!");
        finishAuth("/user-profile");
      } else {
        toast.error(data?.message || "Could not save details.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!formData.email) {
      toast.error("Please enter your email first.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();

      if (data && data.success) {
        toast.success("OTP sent to your email for password reset.");
        setForgotMode(true);
        setStep(2);
        setTimer(300);
        setCanResend(false);
      } else {
        toast.error(data?.message || "Could not send OTP.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email, newPassword, otp: resetOtp }),
      });

      const data = await res.json();

      if (data && data.success) {
        toast.success("Password reset successful. Please login.");
        setForgotMode(false);
        setResetOtp("");
        setStep(1);
        setState("Login");
        setFormData({ ...formData, password: "" });
      } else {
        toast.error(data?.message || "Failed to reset password.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${backend_url}/api/auth/resend-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();

      if (data && data.success) {
        toast.success("OTP resent to your email.");
        setTimer(300);
        setCanResend(false);
      } else {
        toast.error(data?.message || "Could not resend OTP.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Spinner />}
      <div
        className="w-full min-h-full pb-10 pt-24 flex justify-center px-4"
        style={{ background: "linear-gradient(180deg, var(--brand-surface) 0%, var(--brand-bg) 60%)" }}
      >
        <div className="w-full max-w-md bg-white p-8 shadow-xl rounded-2xl border border-[var(--brand-primary-100)] h-fit">
          {/* Login / Sign Up switcher — always visible so registering is never
              buried in fine print at the bottom of the form. */}
          {step === 1 && !forgotMode && (
            <div className="flex mb-6 p-1 rounded-xl gap-1" style={{ background: "var(--brand-primary-50)" }}>
              {["Login", "Sign Up"].map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => setState(option)}
                  className={`flex-1 py-2.5 rounded-lg text-sm font-bold transition-all ${
                    state === option ? "text-white shadow" : "text-gray-500 hover:text-gray-700"
                  }`}
                  style={
                    state === option
                      ? { background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }
                      : {}
                  }
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          <h1 className="text-2xl font-bold text-center mb-6" style={{ color: "var(--brand-primary-800)" }}>
            {forgotMode ? "Reset Password" : step === 4 ? "Complete Your Profile" : state}
          </h1>

          {step === 1 && (
            <div className="flex flex-col gap-5">
              {state === "Sign Up" && (
                <input
                  type="text"
                  placeholder="Your name"
                  name="username"
                  value={formData.username}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                />
              )}
              <input
                type="email"
                placeholder="Email address"
                name="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, [e.target.name]: e.target.value })
                }
                className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
              />

              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    })
                  }
                  className="p-4 pr-12 border border-gray-300 rounded-md text-gray-700 text-base w-full"
                />
                <span
                  className="absolute right-4 top-4 cursor-pointer text-gray-500 text-2xl"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* Terms & Conditions only for Sign Up */}
              {state === "Sign Up" && (
                <div className="mt-4 flex items-start gap-2 text-sm text-gray-600">
                  <input
                    type="checkbox"
                    className="mt-1 cursor-pointer accent-red-500"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                  />
                  <p>
                    By continuing, I agree to the{" "}
                    <span
                      className="text-red-500 underline cursor-pointer"
                      onClick={() => setShowTerms(true)}
                    >
                      terms of use & privacy policy
                    </span>
                    .
                  </p>

                  {showTerms && (
                    <div className="fixed inset-0 flex items-center justify-center max-md:items-end bg-black/50 z-[100] px-4 max-md:px-0">
                      <div className="bg-white rounded-md max-md:rounded-b-none max-md:rounded-t-3xl w-full max-w-6xl h-[90vh] max-md:h-[85vh] relative flex flex-col">
                        {/* Drag-handle affordance — mobile bottom-sheet only */}
                        <div className="md:hidden flex justify-center pt-2.5 pb-1 flex-shrink-0">
                          <span className="w-10 h-1 rounded-full bg-gray-300" />
                        </div>

                        {/* Close button */}
                        <button
                          className="absolute top-4 right-4 text-gray-500 text-2xl font-bold"
                          onClick={() => setShowTerms(false)}
                        >
                          ×
                        </button>

                        {/* Title */}
                        <h2 className="text-2xl font-bold p-6 border-b border-gray-200">
                          Terms & Conditions
                        </h2>

                        {/* Scrollable content */}
                        <div className="p-6 overflow-y-auto flex-1">
                          <TermsAndConditions />
                        </div>

                        {/* Accept button */}
                        <div className="p-6 border-t border-gray-200 flex justify-end">
                          <button
                            onClick={() => {
                              setTermsAccepted(true);
                              setShowTerms(false);
                            }}
                            className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md font-semibold"
                          >
                            Accept
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Buttons */}
              {/* Buttons */}
              <button
                onClick={() => {
                  if (state === "Sign Up" && !termsAccepted) {
                    toast.error("You must accept the terms to continue!");
                    return;
                  }

                  // Call the appropriate function
                  state === "Login" ? handleLogin() : handleAuth();
                }}
                className={`py-3 rounded-xl text-lg font-semibold w-full transition-all ${
                  state === "Sign Up" && !termsAccepted
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "text-white shadow-lg hover:opacity-90 active:scale-[0.98]"
                }`}
                style={
                  state === "Sign Up" && !termsAccepted
                    ? {}
                    : { background: "linear-gradient(90deg, var(--brand-primary-600), var(--brand-secondary-500))" }
                }
              >
                Continue
              </button>

              {state === "Login" && (
                <button
                  onClick={handleForgotPassword}
                  className="text-sm text-red-500 font-medium hover:underline"
                >
                  Forgot password?
                </button>
              )}
            </div>
          )}

          {/* OTP Step */}
          {step === 2 && (
            <div className="flex flex-col gap-5">
              <p className="text-center">
                OTP has been sent to {formData.email}. Please check your inbox.
              </p>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
              />
              <button
                onClick={handleOtpSubmit}
                className="bg-red-500 hover:bg-red-600 text-white py-3 rounded-md text-lg font-semibold"
              >
                Verify OTP
              </button>
              <p className="text-sm text-gray-600 text-center">
                {canResend ? (
                  <>
                    Didn’t get OTP?{" "}
                    <button
                      className="text-red-500 font-semibold underline"
                      onClick={resendOtp}
                    >
                      Resend OTP
                    </button>
                  </>
                ) : (
                  <>
                    OTP valid for:{" "}
                    <span className="font-medium text-gray-900">
                      {formatTime(timer)}
                    </span>
                  </>
                )}
              </p>
            </div>
          )}

          {/* Reset Password Step */}
          {step === 3 && forgotMode && (
            <div className="flex flex-col gap-5">
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="p-4 pr-12 border border-gray-300 rounded-md text-gray-700 text-base w-full"
                />
                <span
                  className="absolute right-4 top-4 cursor-pointer text-gray-500 text-2xl"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              <button
                onClick={handleResetPassword}
                className="bg-green-500 hover:bg-green-600 text-white py-3 rounded-md text-lg font-semibold"
              >
                Set New Password
              </button>
            </div>
          )}

          {/* Complete Profile Step (after Sign Up OTP verification) */}
          {step === 4 && (
            <div className="flex flex-col gap-4">
              <p className="text-center text-gray-600 text-sm -mt-2">
                Just a few more details so checkout is quick next time.
              </p>

              <div>
                <input
                  type="tel"
                  placeholder="Phone number (10 digits)"
                  value={profileDetails.phoneNumber}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "");
                    if (v.length <= 10) {
                      setProfileDetails({ ...profileDetails, phoneNumber: v });
                      setProfileErrors({ ...profileErrors, phoneNumber: "" });
                    }
                  }}
                  className={`p-4 border rounded-md text-gray-700 text-base w-full ${
                    profileErrors.phoneNumber ? "border-red-400" : "border-gray-300"
                  }`}
                />
                {profileErrors.phoneNumber && (
                  <p className="text-red-500 text-xs mt-1">{profileErrors.phoneNumber}</p>
                )}
              </div>

              <input
                type="tel"
                placeholder="WhatsApp number (optional)"
                value={profileDetails.whatsappNumber}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/g, "");
                  if (v.length <= 10) {
                    setProfileDetails({ ...profileDetails, whatsappNumber: v });
                  }
                }}
                className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
              />

              <input
                type="text"
                placeholder="Address"
                value={profileDetails.address}
                onChange={(e) => setProfileDetails({ ...profileDetails, address: e.target.value })}
                className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
              />

              <div className="grid grid-cols-2 gap-3">
                <input
                  type="text"
                  placeholder="City"
                  value={profileDetails.city}
                  onChange={(e) => setProfileDetails({ ...profileDetails, city: e.target.value })}
                  className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                />
                <input
                  type="text"
                  placeholder="Pincode"
                  value={profileDetails.pincode}
                  onChange={(e) =>
                    setProfileDetails({
                      ...profileDetails,
                      pincode: e.target.value.replace(/\D/g, "").slice(0, 6),
                    })
                  }
                  className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <select
                  value={profileDetails.country}
                  onChange={(e) =>
                    setProfileDetails({ ...profileDetails, country: e.target.value, state: "" })
                  }
                  className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                >
                  <option value="">Country</option>
                  <option value="India">India</option>
                  <option value="Other">Other</option>
                </select>

                {profileDetails.country === "India" ? (
                  <select
                    value={profileDetails.state}
                    onChange={(e) => setProfileDetails({ ...profileDetails, state: e.target.value })}
                    className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                  >
                    <option value="">State</option>
                    {indianStates.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    placeholder="State / Region"
                    value={profileDetails.state}
                    onChange={(e) => setProfileDetails({ ...profileDetails, state: e.target.value })}
                    className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
                  />
                )}
              </div>

              <p className="text-xs text-gray-400 -mb-2">Optional — helps us personalise offers for you</p>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-gray-500">Date of birth</label>
                  <input
                    type="date"
                    value={profileDetails.dob}
                    onChange={(e) => setProfileDetails({ ...profileDetails, dob: e.target.value })}
                    className="p-4 border border-gray-300 rounded-md text-gray-700 text-base w-full"
                  />
                </div>
                <div>
                  <label className="text-xs text-gray-500">Anniversary</label>
                  <input
                    type="date"
                    value={profileDetails.anniversary}
                    onChange={(e) => setProfileDetails({ ...profileDetails, anniversary: e.target.value })}
                    className="p-4 border border-gray-300 rounded-md text-gray-700 text-base w-full"
                  />
                </div>
              </div>

              <button
                onClick={handleCompleteProfile}
                className="bg-red-500 hover:bg-red-600 text-white py-3 rounded-md text-lg font-semibold w-full"
              >
                Save & Continue
              </button>

              <button
                onClick={() => finishAuth("/user-profile")}
                className="text-sm text-gray-500 font-medium hover:underline text-center"
              >
                Skip for now
              </button>
            </div>
          )}

          {/* Switch Login/Sign Up */}
          {step === 1 && (
            <p className="mt-4 text-center text-gray-600 text-sm">
              {state === "Login" ? (
                <>
                  Create an account?{" "}
                  <span
                    className="text-red-500 font-semibold cursor-pointer"
                    onClick={() => {
                      setState("Sign Up");
                      setForgotMode(false);
                    }}
                  >
                    Click here
                  </span>
                </>
              ) : (
                <>
                  Already have an account?{" "}
                  <span
                    className="text-red-500 font-semibold cursor-pointer"
                    onClick={() => {
                      setState("Login");
                      setForgotMode(false);
                    }}
                  >
                    Login here
                  </span>
                </>
              )}
            </p>
          )}
        </div>
      </div>

    </>

    //     <>
    //     {loading && <Spinner />}
    //     <div className="w-full min-h-full pb-10 bg-pink-100 pt-24 flex justify-center">
    //       <div className="w-full max-w-md bg-white p-8 shadow-lg rounded-md">
    //         <h1 className="text-2xl font-bold text-center mb-6">
    //           {forgotMode ? "Reset Password" : state}
    //         </h1>

    //         {step === 1 && (
    //           <div className="flex flex-col gap-5">
    //             {state === "Sign Up" && (
    //               <input
    //                 type="text"
    //                 placeholder="Your name"
    //                 name="username"
    //                 value={formData.username}
    //                 onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
    //                 className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
    //               />
    //             )}
    //             <input
    //               type="email"
    //               placeholder="Email address"
    //               name="email"
    //               value={formData.email}
    //               onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
    //               className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
    //             />

    //             <div className="relative">
    //               <input
    //                 type={showPassword ? "text" : "password"}
    //                 placeholder="Password"
    //                 name="password"
    //                 value={formData.password}
    //                 onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
    //                 className="p-4 pr-12 border border-gray-300 rounded-md text-gray-700 text-base w-full"
    //               />
    //               <span
    //                 className="absolute right-4 top-4 cursor-pointer text-gray-500 text-2xl"
    //                 onClick={() => setShowPassword(!showPassword)}
    //               >
    //                 {showPassword ? <FaEyeSlash /> : <FaEye />}
    //               </span>
    //             </div>
    //             <button
    //               onClick={handleLogin}
    //               className="bg-red-500 hover:bg-red-600 text-white py-3 rounded-md text-lg font-semibold"
    //             >
    //               Continue
    //             </button>

    //             {state === "Login" && (
    //               <button
    //                 onClick={handleForgotPassword}
    //                 className="text-sm text-red-500 font-medium hover:underline"
    //               >
    //                 Forgot password?
    //               </button>
    //             )}
    //           </div>
    //         )}

    //         {step === 2 && (
    //           <div className="flex flex-col gap-5">
    //             <p className="text-center"> OTP has been sent to {formData.email}. Please check your inbox.</p>
    //             <input
    //               type="text"
    //               placeholder="Enter OTP"
    //               value={otp}
    //               onChange={(e) => setOtp(e.target.value)}
    //               className="p-4 border border-gray-300 rounded-md text-gray-700 text-base"
    //             />
    //             <button
    //               onClick={handleOtpSubmit}
    //               className="bg-red-500 hover:bg-red-600 text-white py-3 rounded-md text-lg font-semibold"
    //             >
    //               Verify OTP
    //             </button>
    //             <p className="text-sm text-gray-600 text-center">
    //               {canResend ? (
    //                 <>
    //                   Didn’t get OTP?{" "}
    //                   <button
    //                     className="text-red-500 font-semibold underline"
    //                     onClick={resendOtp}
    //                   >
    //                     Resend OTP
    //                   </button>
    //                 </>
    //               ) : (
    //                 <>OTP valid for: <span className="font-medium text-gray-900">{formatTime(timer)}</span></>
    //               )}
    //             </p>
    //           </div>
    //         )}

    //         {step === 3 && forgotMode && (
    //           <div className="flex flex-col gap-5">
    //             <div className="relative">
    //               <input
    //                 type={showPassword ? "text" : "password"}
    //                 placeholder="New Password"
    //                 value={newPassword}
    //                 onChange={(e) => setNewPassword(e.target.value)}
    //                 className="p-4 pr-12 border border-gray-300 rounded-md text-gray-700 text-base w-full"
    //               />
    //               <span
    //                 className="absolute right-4 top-4 cursor-pointer text-gray-500 text-2xl"
    //                 onClick={() => setShowPassword(!showPassword)}
    //               >
    //                 {showPassword ? <FaEyeSlash /> : <FaEye />}
    //               </span>
    //             </div>
    //             <button
    //               onClick={handleResetPassword}
    //               className="bg-green-500 hover:bg-green-600 text-white py-3 rounded-md text-lg font-semibold"
    //             >
    //               Set New Password
    //             </button>
    //           </div>
    //         )}

    //         {step === 1 && (
    //           <p className="mt-4 text-center text-gray-600 text-sm">
    //             {state === "Login" ? (
    //               <>
    //                 Create an account?{" "}
    //                 <span
    //                   className="text-red-500 font-semibold cursor-pointer"
    //                   onClick={() => {
    //                     setState("Sign Up");
    //                     setForgotMode(false);
    //                   }}
    //                 >
    //                   Click here
    //                 </span>
    //               </>
    //             ) : (
    //               <>
    //                 Already have an account?{" "}
    //                 <span
    //                   className="text-red-500 font-semibold cursor-pointer"
    //                   onClick={() => {
    //                     setState("Login");
    //                     setForgotMode(false);
    //                   }}
    //                 >
    //                   Login here
    //                 </span>
    //               </>
    //             )}
    //           </p>
    //         )}

    //       </div>
    //     </div>

    // <ToastContainer position="top-center" autoClose={3000} />
    // </>
  );
};

export default LoginSignup;
